"use client"

import { useContext, useEffect, useRef, useState } from "react";
import { ModalContext } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import styles from "../styles.module.scss";
import * as cheerio from "cheerio";
import cn, { clsx } from "clsx";
import { dateFormatterWithTime } from "@/helpers/dateFormatter";
import Link from "next/link";

import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";


const AuthorDetails = ({ data, enabled }) => {
  return <>
  {!!(data.data) && enabled ?
    <div className={cn(styles.authorTile, "mt-4 mb-5")}>
    <div className="flex justify-between items-center">
      <div className={"flex gap-4"}>
        <img src={data?.data?.attributes?.Picture?.data?.attributes?.url} />
        <div className="flex flex-col justify-center text-left">
          <a className="!m-0" href={"/author/"+data?.data?.attributes?.slug || "#"}>{data?.data?.attributes?.name}</a>
          <h3 className={cn(styles.authorTitle, "!m-0")}>Author</h3>
        </div>
      </div>
    </div>
  </div>
  : null 
  }
  </>
}

function ContentBody(props:any){
    const { data, requestACallCTA, enrollNowCTA, updatedAt} = props;
    const {content="", author} = data
    const htmlContainerRef = useRef(null);
    const { modalDispatch } = useContext(ModalContext)


    const [tableofContentList, setTableList] = useState([])
    const [isActiveMenu, setActiveMenu] = useState<number | null>(null)

    const isWhitespaceString = str => !str.replace(/\s/g, '').length

    const convertHtmlToElements = (htmlString) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      return doc.body.childNodes; // Returns a NodeList of the parsed elements
    };

    useEffect(() => {
        const container = htmlContainerRef.current;
        const htmlDoc = convertHtmlToElements(content)
        const allH2Tags = Array.from(htmlDoc).filter(node => {
          if (node instanceof HTMLElement && node.tagName === 'H2' && !isWhitespaceString(node.innerText)) {
            return node
          }
        }
        )
        setTableList(allH2Tags)


        const handleClickForAnchor = (event) => { 
          event.preventDefault();
          pushToDataLayer(
            {
              event :	"lead_initiate",
              cta_text : "NA",
              section_name : "hero_banner",
              header_title : "NA",
              page_type	: getGlobalStateValue("pageType"),
              page_url : window.location.href || "NA"
            }
          );
          modalDispatch({
            type: IModalActions.OpenModal,
            data: { modalType: ModalTypes["ConnectModal"], isModalOpen: true }
          });
        }
    
        const handleClick = (event) => {
          event.preventDefault(); 
          // Add your custom logic here
          pushToDataLayer(
            {
              event :	"lead_initiate",
              cta_text : event?.target?.innerText || "NA",
              section_name : "middle",
              header_title : "Get Complete Details From Expert",
              page_type	: getGlobalStateValue("pageType"),
              page_url : window.location.href || "NA"
            }
          )
          modalDispatch({
            type: IModalActions.OpenModal,
            data: { modalType: ModalTypes["ConnectModal"], isModalOpen: true }
          });
        };

        const handleClickButton2 = (event) => {
          event.preventDefault(); 
          pushToDataLayer(
            {
              event :	"lead_initiate",
              cta_text : event?.target?.innerText || "NA",
              section_name : "footer",
              header_title : "Are you ready? To Take The Next Step In Your Career?",
              page_type	: getGlobalStateValue("pageType"),
              page_url : window.location.href || "NA"
            }
          )
          // Add your custom logic here
          modalDispatch({
            type: IModalActions.OpenModal,
            data: { modalType: ModalTypes["ConnectModal"], isModalOpen: true }
          });
        };

        const attachEventListener = () => {
          container.querySelectorAll('h2').forEach((h2) => {
            if(!isWhitespaceString(h2.innerText))
              h2.setAttribute('id', h2.innerText.toLowerCase().replaceAll(' ', ''))
          });
          const button = container?.querySelector('#requestCallBtn');
          const anchorTag = container?.querySelector('a[href*="?modalId=ConnectModal"]');
          if(anchorTag){
            anchorTag.addEventListener('click', handleClickForAnchor);
          }
          if (button) {
            button.addEventListener('click', handleClick);
          }
          const button2 = container?.querySelector('#enrollBtn');
          if (button2) {
            button2.addEventListener('click', handleClickButton2);
          }
        };
        attachEventListener();
    
        // Create a MutationObserver to monitor DOM changes
        const observer = new MutationObserver(() => {
          attachEventListener(); // Reattach the event listener on DOM changes
        });
    
        // Observe the container for changes
        if (container) {
          observer.observe(container, { childList: true, subtree: true });
        }

        return () => {
          if (container) {
            observer.disconnect(); // Stop observing
            const anchorTag = container?.querySelector('a[href*="?modalId=ConnectModal"]');
            if(anchorTag){
              anchorTag.removeEventListener('click', handleClickForAnchor);
            }
            const button = container.querySelector('#requestCallBtn');
            if (button) {
              button.removeEventListener('click', handleClick);
            }
            const button2 = container.querySelector('#enrollBtn');
            if (button2) {
              button2.removeEventListener('click', handleClickButton2);
            }
          }
        };
    }, [content]);
    
    return (<>
      <div className={clsx(styles.tableContentWrapper, 'px-3 py-6 ml-5')}>
        {tableofContentList.length > 0 && <div className="max-h-72 overflow-auto">
          <h4 className={cn("mb-3 font-bold text-center", styles.tableHeading)}>Table of Content</h4>
          <ul className="list-disc">
          {
             tableofContentList.length  ? tableofContentList.map((h, ind)=>{
              if(!isWhitespaceString(h.innerText))
              return <li className="mb-1"><Link onClick={(e) => {
                e.preventDefault();
                setActiveMenu(ind);
                document.getElementById(h.innerText.toLowerCase().replaceAll(' ', ''))?.scrollIntoView({ behavior: 'smooth' });
              }}  className={cn("text-[0.6rem] leading-1 block", {"text-[#1a325d] font-bold": isActiveMenu == ind})} href={``}>{h.innerText}</Link></li>
            }) : <li className="mb-1 text-[0.6rem] leading-1 block">No Content</li>
          }
          </ul>
        </div>}
      </div>
      <div className={cn(styles.root)}>
      <div>
        <div>
          {/* heading */}
          <h1>
            <strong>{props.heading}</strong>
          </h1>
          <p className={cn(styles.blogCreateDate, "text-right my-3")}>Updated: {dateFormatterWithTime(updatedAt, true)}</p>
        </div>
        <div className={cn(styles.blog,"mt-5")}>
        <div
            ref={htmlContainerRef}
            dangerouslySetInnerHTML={{
            __html: removeUnwantedContent(content)
            .replaceAll(
              "<strong>{requestACallCTA}</strong>", requestACallCTA || ""
              )
              .replaceAll(
                "{requestACallCTA}", requestACallCTA || ""
              )
              .replaceAll(
                "<strong>{enrollNowCTA}</strong>", enrollNowCTA || ""
              )
              .replaceAll(
                "{enrollNowCTA}", enrollNowCTA || ""
              )
          }}
        />
        </div>
      </div>
      <AuthorDetails data={author} enabled={Object.keys(author).length > 0} />
      </div>
    </>
    );
    
}

export default ContentBody;


function removeUnwantedContent(content: any) {
  const MAX_AMP_CSS_SIZE = 99;
  if (typeof content != "string") {
      return "";
  }
  const $ = cheerio.load(content, null, false);

  $('h2').attr('style', 'text-transform:none;white-space:normal;widows:2;word-spacing:0px;');

  $('col').each((_, el) => {
      $(el).removeAttr('width');
  });

  $("table").each(function () {
      $(this).wrap(`<div class="amp-table-container"></div>`);
  });

  $('style[amp-custom]').removeAttr('amp-custom');
  const styleTags = $('style');
  if (styleTags.length > 0) {
      styleTags.each((i, el) => {
          $(el).remove();
      });
  }

  $('[style]').each((i, el) => {
      const styleContent = $(el).attr('style');
      if (styleContent.length > MAX_AMP_CSS_SIZE) {
          $(el).removeAttr('style');
      }
  });

  
  $("body :not(td) ul li:first-child > p").attr('style', 'white-space:nowrap;');
  $("td ul li").css("display", "flex");
  $("ul li").each(function () {
    const hasHeading = $(this).find("h1, h2, h3, h4, h5, h6").length > 0;
    if (hasHeading) {
      $(this).css({
        display: "flex",
      });
    }
  });

  $("ul li > strong:first-child").css({ 'white-space': 'nowrap', 'margin-right': '5px' });
  $("ul li > a").css({
    'white-space': 'nowrap',
    'margin-right': '10px'
  });
  $("ul").attr('style', 'padding-inline-start:10px;');

  $('meta').remove();

  return $.root().html();
}
